// utils/slugify.js
export const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
};

// Approximate reverse — NOT guaranteed to match original exactly
export const unslugify = (slug) => {
  if (!slug) return "";
  return slug
    .toString()
    .replace(/-/g, ' ')                          // hyphens -> spaces
    .replace(/\s+/g, ' ')                        // collapse extra spaces
    .trim()
    .replace(/\w\S*/g, (word) =>                 // Title Case each word
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
};
